import type { ReactNode } from "react";
import { Text } from "components/text";

export const CountBadge = ({
  count,
  children,
}: {
  count: number | null;
  children: ReactNode;
}) => (
  <span className="relative inline-flex">
    {children}
    {count != null && (
      <span className="absolute -right-3.5 -top-[13px] flex h-4 min-w-4 items-center justify-center rounded-full bg-current px-0.5 pt-0">
        <Text as="span" variant="countBadge">
          {count}
        </Text>
      </span>
    )}
  </span>
);
